const FeedbackIcon = () => (
	<svg
		fill='currentColor'
		height='16'
		viewBox='0 0 16 16'
		width='16'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0 16V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H14.5C14.9125 0 15.2656 0.146876 15.5594 0.440626C15.8531 0.734376 16 1.0875 16 1.5V11.5C16 11.9125 15.8531 12.2656 15.5594 12.5594C15.2656 12.8531 14.9125 13 14.5 13H3L0 16ZM2.375 11.5H14.5V1.5H1.5V12.375L2.375 11.5Z'
			fill='currentColor'
		/>
	</svg>
)

export { FeedbackIcon }
